import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';

const AsignacionesHeader = ({ canCreateAsignacion, onNuevaAsignacion, onCargaMasiva }) => {
    return (
        <Row className="mt-4">
            <Col xs={12} className="d-flex justify-content-between align-items-center">
                <div>
                    <h5 style={{ color: '#212529', marginBottom: '4px' }}>Asignaciones Recientes</h5>
                    <p style={{ color: '#6c757d', marginBottom: '0', fontSize: '0.9rem' }}>
                        Últimas asignaciones de extras realizadas
                    </p>
                </div>
                {canCreateAsignacion && (
                    <div className="d-flex align-items-center gap-2">
                        <Button
                            variant="outline-success"
                            onClick={onCargaMasiva}
                            className="d-flex align-items-center gap-2"
                        >
                            <FaIcons.FaFileExcel />
                            Carga Masiva
                        </Button>
                        <Button
                            variant="success"
                            onClick={onNuevaAsignacion}
                            className="d-flex align-items-center gap-2"
                        >
                            <FaIcons.FaPlus />
                            Nueva Asignación
                        </Button>
                    </div>
                )}
            </Col>
        </Row>
    );
};

AsignacionesHeader.propTypes = {
    canCreateAsignacion: PropTypes.bool.isRequired,
    onNuevaAsignacion: PropTypes.func.isRequired,
    onCargaMasiva: PropTypes.func.isRequired
};

export default AsignacionesHeader;
